import { useServicesContext } from '../context';
export const useTranslations = () => {
    var _a;
    const { 'dbad:audi-i18n-service': i18nService, 'locale-service': localeService, 's2:logger': logger = console, } = useServicesContext().getFeatureServices();
    const data = i18nService === null || i18nService === void 0 ? void 0 : i18nService.getMessages();
    const language = (_a = localeService === null || localeService === void 0 ? void 0 : localeService.language) !== null && _a !== void 0 ? _a : 'default';
    if (!data || !language) {
        logger.error('error in locale-service or i18nService!');
        return {};
    }
    return data[language];
};
